// screens/registration/Region.js
import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  useTheme,
  CircularProgress,
  Select,
  FormControl,
  Menu,MenuItem
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";

import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import SingleSelectDropdown from "../../../components/SingleSelectDropdown"; // ✅ use single select
// your reusable dropdown
import { BASE_URL } from "../../../components/BaseUrl";
import { setProfileDraft } from "./ProfileDraft";
import SearchableCompanyDropdown from "../../../components/companySearchableDropdown";
import profiledone from "../../../assets/profiledone.svg";
import SearchableDropdown from "../../../components/SearchableComponent";
import SearchableCompanyInput from "../../../components/SearchInput";
import CompanyValidatorInput from "../../../components/companyValidatorInput"
const Region = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
const hireRef = useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const profileUpdateToken =
    useSelector((s) => s.auth?.profileUpdateToken) ||
    localStorage.getItem("profileUpdateToken");

  const [loading, setLoading] = useState(false);

  // companies & departments
  // companies & departments
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [loadingDepartments, setLoadingDepartments] = useState(false);


  /* -------------------- FETCH COMPANIES --------------------- */
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoadingCompanies(true);
        const res = await fetch(`${BASE_URL}/public/companies`);
        const data = await res.json();
        console.log("data",data)
        if (!res.ok || data.error) throw new Error(data.message);
        const opts = data.data.companies.map((c) => ({
           label: `${c.legal_name} (${c.business_email})`,
          value: c.id,
        }));
        setCompanies(opts);
      } catch (err) {
        toast.error(err.message || "Failed to load companies");
      } finally {
        setLoadingCompanies(false);
      }
    };
    fetchCompanies();
  }, []);

    useEffect(() => {
    if (!selectedCompany) return;

    const fetchDepartments = async () => {
      try {
        setLoadingDepartments(true);
        const res = await fetch(
          `${BASE_URL}/public/departmentsByCompId/${selectedCompany}`
        );
        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.message);
                    const departmentsList = data.data?.departments || [];

      if (departmentsList.length === 0) {
        toast.error("No department found in this company");
      }
      
        const opts = data.data.departments.map((d) => ({
          label: d.name,
          value: d.id,
        }));
        setDepartments(opts);
      } catch (err) {
        toast.error(err.message || "Failed to load departments");
      } finally {
        setLoadingDepartments(false);
      }
    };
    fetchDepartments();
  }, [selectedCompany]);

  const formik = useFormik({
    initialValues: {
      worker_id: "",
      designation: "",
      employee_type: "",
      hire_date: "",
      shift_schedule: "",
      salary: "",
      work_hours: "",
      primary_color: "#1976d2",
      secondary_color: "#ffffff",
    },
    onSubmit: async (values) => {
      if (selectedCompany.length === 0 || selectedDepartment.length === 0) {
toast.error(t("select_company_department"));        return;
      }

      setLoading(true);
const today = new Date().toISOString().split("T")[0];

      try {
        const draftUpdate = {
      company_id: selectedCompany,
          department_id: selectedDepartment,
          // worker_id: values.worker_id,
         
          designation: values.designation,
          employee_type: values.employee_type,
          // hire_date: values.hire_date,
          shift_schedule: values.shift_schedule,
          salary: values.salary,
          work_hours: values.work_hours,
          primary_color: values.primary_color,
          secondary_color: values.secondary_color,
        };
draftUpdate.hire_date =
  values.hire_date && values.hire_date.trim() !== ""
    ? values.hire_date
    : today;
        const updated = setProfileDraft(draftUpdate);
        console.log("Selected department_id:", selectedDepartment);

        console.log("Saving draft with company_id:", selectedCompany, "department_id:", selectedDepartment);

        console.log("📦 Profile Draft saved (Region/Worker details step):", updated);

        // toast.success("Worker details saved to draft");

        navigate("/face-scanning");
      } catch (e) {
        toast.error(e.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  const isError = (name) => formik.touched[name] && formik.errors[name];
const [isContinueClicked, setIsContinueClicked] = useState(false);
const shiftOptions = [
  { label: "Morning", value: "Morning" },
  { label: "Evening", value: "Evening" },
  { label: "Night", value: "Night" },
  { label: "Rotational", value: "Rotational" },
];

  return (
    <Box sx={{ py: isMobile ? 5 : 8, px: 2, mt: isMobile ? 2 : 0 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          alignItems: "center",
        }}
      >
        <BaseCard
          maxWidth={
            isMobile ? "100%" : isTablet ? "70%" : isLaptop ? "70%" : "40%"
          }
        >
          {/* Stepper */}
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
              <Box
                sx={{
                  width: isMobile ? 55 : isTablet ? 70 : 93,
                  height: 2,
                  backgroundColor: "#091E4224",
                }}
              />
              <Box
                sx={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  backgroundColor: "#006EC2",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
                2
              </Box>
              <Box
                sx={{
                  width: isMobile ? 55 : isTablet ? 70 : 93,
                  height: 2,
                  backgroundColor: "#091E4224",
                }}
              />
              <Box
                sx={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  color: "#BCBFC2",
                  border: "2px solid  #091E4224",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
                3
              </Box>
            </Box>
          </Box>

          <CustomText
            sx={{
              ...textStyles.h4,
              color: "#172B4D",
              textAlign: "left",
              fontSize: "26px",
            }}
          >
           {t("region.title")}
          </CustomText>
          <CustomText
            sx={{ ...textStyles.body5, color: "#6B778C", pt: 1.2, textAlign: "left" }}
          >
         {t("region.subtitle")}
          </CustomText>

          <form onSubmit={formik.handleSubmit} style={{ marginTop: "20px" }}>
      
            {/* <SearchableCompanyDropdown
  value={selectedCompany}
  onChange={setSelectedCompany}
  loading={loadingCompanies}
  options={companies.map((c) => ({
    label: c.label,         // legal name
    value: c.value,         // id
    email: c.label.match(/\((.*?)\)/)?.[1] || "", // extract email
  }))}
  placeholder={t("region.selectCompany")}
/> */}

<CompanyValidatorInput
  options={companies.map((c) => ({
    label: c.label,
    value: c.value,
    email: c.label.match(/\((.*?)\)/)?.[1] || "",
  }))}
  value={selectedCompany}
  onChange={(companyObj) => setSelectedCompany(companyObj)}
  placeholder={t("region.selectCompany")}
/>



            {/* Department */}
            <Box sx={{mt:3,}}>
         {selectedCompany && (
        
                  

<SearchableDropdown
  value={
    // Convert stored ID -> department name to show in UI
    departments.find((d) => d.value === selectedDepartment)?.label || ""
  }
  onChange={(selectedLabel) => {
    // Convert UI label -> department ID to store
    const selectedObj = departments.find((d) => d.label === selectedLabel);
    setSelectedDepartment(selectedObj?.value || "");
  }}
  options={departments.map((d) => d.label)} // UI sees only names
  placeholder={t("region.selectDepartment")}
  disabled={!selectedCompany || loadingDepartments}
  loading={loadingDepartments}
/>


            )}
            </Box>



{/* Designation + Employee Type */}
<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
    {t("position")}
    </label>
    <input
      name="designation"
      value={formik.values.designation}
      onChange={formik.handleChange}
      className="project_input"
      style={{ height: "42px", borderRadius: 6, padding: "0 10px" }}
    />
  </Box>

  {/* <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
     {t("region.employeeType")}
    </label>
    <input
      name="employee_type"
      value={formik.values.employee_type}
      onChange={formik.handleChange}
      className="project_input"
      style={{ height: "42px", borderRadius: 6, padding: "0 10px" }}
    />
  </Box> */}
  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
  <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
    {t("region.employeeType")}
  </label>

  <FormControl fullWidth size="small">
    <Select
      value={formik.values.employee_type}
      onChange={(e) =>
        formik.setFieldValue("employee_type", e.target.value)
      }
      displayEmpty
      sx={{
        height: 42,
        borderRadius: "6px",
        fontFamily: "Poppins, sans-serif",
        fontSize: "14px",
        backgroundColor: "#fff",
        "& fieldset": {
          borderColor: "#DFE1E6",
          borderWidth: "2px",
        },
        "&:hover fieldset": {
          borderColor: "#1976d2",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1976d2",
          boxShadow: "0 0 0 2px rgba(25,118,210,0.08)",
        },
      }}
    >
     

      <MenuItem value="Full-Time" sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }}>
        {t("empFullTime")}
      </MenuItem>

      <MenuItem value="Part-Time" sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }}>
        {t("empPartTime")}
      </MenuItem>

      <MenuItem value="Intern" sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }}>
        {t("empIntern")}
      </MenuItem>

      <MenuItem value="Contract" sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }}>
        {t("empContract")}
      </MenuItem>
    </Select>
  </FormControl>
</Box>

</Box>

{/* Hire Date + Shift Schedule */}
<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
     {t("region.hireDate")}
    </label>
 
    <input
        ref={hireRef}
    onClick={() => hireRef.current?.showPicker()} 
  type="date"
  name="hire_date"
  value={formik.values.hire_date}
  onChange={(e) => {
    let v = e.target.value;

    let [year, month, day] = v.split("-");

    // Auto-correct year
    if (year && year.length > 4) {
      year = year.slice(0, 4);
      v = [year, month, day].filter(Boolean).join("-");
    }

    formik.setFieldValue("hire_date", v);
  }}
  className="project_input"
  style={{ height: "42px", borderRadius: 6, padding: "0 10px" }}
/>

  </Box>


<Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
  <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
    {t("region.shiftSchedule")}
  </label>

  <FormControl fullWidth size="small">
    <Select
      value={formik.values.shift_schedule}
      onChange={(e) =>
        formik.setFieldValue("shift_schedule", e.target.value)
      }
      displayEmpty
      sx={{
        height: 42,
        borderRadius: "6px",
        fontFamily: "Poppins, sans-serif",
        fontSize: "14px",
        backgroundColor: "#fff",
        "& fieldset": {
          borderColor: "#DFE1E6",
          borderWidth: "2px",
        },
        "&:hover fieldset": {
          borderColor: "#1976d2",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1976d2",
          boxShadow: "0 0 0 2px rgba(25,118,210,0.08)",
        },
      }}
    >
     

      <MenuItem value="Morning" sx={{fontSize:"13px",fontFamily: 'Poppins, sans-serif',}}>{t("shiftMorning")}</MenuItem>
      <MenuItem value="Evening" sx={{fontSize:"13px",fontFamily: 'Poppins, sans-serif',}}>{t("shiftEvening")}</MenuItem>
      <MenuItem value="Night" sx={{fontSize:"13px",fontFamily: 'Poppins, sans-serif',}}> {t("shiftNight")}</MenuItem>
      <MenuItem value="Rotational" sx={{fontSize:"13px",fontFamily: 'Poppins, sans-serif',}}>{t("shiftRotational")}</MenuItem>
    </Select>
  </FormControl>
</Box>



</Box>

{/* Salary + Work Hours */}
<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
    {t("settings.salary")}
    </label>
    <input
       type="number"
      name="salary"
      value={formik.values.salary}
      onChange={formik.handleChange}
      className="project_input"
      style={{ height: "42px", borderRadius: 6, padding: "0 10px" }}
    />
  </Box>

  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ color: "#626F86", fontSize: 14, marginBottom: 6 }}>
     {t("settings.workHours")}
    </label>
    <input
       type="number"
      name="work_hours"
      value={formik.values.work_hours}
      onChange={formik.handleChange}
      className="project_input"
      style={{ height: "42px", borderRadius: 6, padding: "0 10px" }}
    />
  </Box>
</Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
              <CustomButton
                size="medium"
                label={t("back")}
                variant="text"
                disabled={isContinueClicked} 
                onClick={() => navigate(-1)}
                sx={{
                  color: "black",
                  px: 6,
                                   backgroundColor: isContinueClicked ? "#f0f0f0" : "white", // light grey if disabled
    color: isContinueClicked ? "#999" : "black",
    "&:hover": {
      backgroundColor: isContinueClicked ? "#f0f0f0" : "white",
      color: isContinueClicked ? "#999" : "black",
    },
                }}
              />
              <CustomButton
                 onClick={() => setIsContinueClicked(true)}  
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {loading && <CircularProgress size={18} sx={{ color: "#fff" }}/> }
                    {t("next")}
                  </Box>
                }
                type="submit"
                size="medium"
                sx={{ px: 6, height: 20 }}
              />
            </Box>
          </form>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default Region;










